import React from 'react'
import { Link } from 'react-router-dom'
import { CTA } from '..'

const Projects = () => {
    return (
        <>
            <section className="text-gray-600 body-font pt-10">
                <div className="container px-5 py-24 mx-auto">
                    <div className="flex flex-col">
                        <div className="h-1 bg-gray-200 rounded overflow-hidden">
                            <div className="w-24 h-full bg-indigo-500"></div>
                        </div>
                        <div className="flex flex-wrap sm:flex-row flex-col py-6 mb-12">
                            <h1 className="sm:w-2/5 text-gray-900 font-medium title-font text-2xl mb-2 sm:mb-0">
                                Evoteam jamoasi tomonidan yaratilgan loyihalar — bu zamonaviy texnologiyalar asosida ishlab chiqilgan, amaliy foydaga ega va real muammolarga yechim bo‘luvchi xizmatlardir.
                            </h1>
                            <p className="sm:w-3/5 leading-relaxed text-base sm:pl-10 pl-0 font-sans">
                                Har bir loyihamiz qulaylik, tezkorlik va samaradorlikni ta’minlashga qaratilgan. Quyida siz Evoteam jamoasi tomonidan amalga oshirilgan ba’zi loyihalar bilan tanishishingiz mumkin.
                            </p>
                        </div>
                    </div>

                    <div className="flex flex-wrap sm:-m-4 -mx-4 -mb-10 -mt-4">
                        {/* TRACE Bot */}
                        <div className="p-4 md:w-1/3 sm:mb-0 mb-6">
                            <div className="rounded-lg h-64 overflow-hidden">
                                <img alt="TRACE Bot" className="object-cover object-center h-full w-full" src="/img/tracebotimg.jpg" />
                            </div>
                            <h2 className="text-xl font-medium title-font text-gray-900 mt-5">TRACE Bot</h2>
                            <p className="text-base leading-relaxed mt-2">
                                TRACE Bot zavodlar va yirik korxonalar uchun davomatni boshqarishni yaxshilash maqsadida ishlab chiqilgan.
                            </p>
                            <Link to="/loyihalarmiz/trace-bot" className="text-indigo-500 inline-flex items-center mt-3">
                                Ko'rish
                                <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" className="w-4 h-4 ml-2" viewBox="0 0 24 24">
                                    <path d="M5 12h14M12 5l7 7-7 7"></path>
                                </svg>
                            </Link>
                        </div>

                        {/* Budget Manager Bot */}
                        <div className="p-4 md:w-1/3 sm:mb-0 mb-6">
                            <div className="rounded-lg h-64 overflow-hidden">
                                <img alt="Budget Manager Bot" className="object-cover object-center h-full w-full" src="/img/budgetbot.jpg" />
                            </div>
                            <h2 className="text-xl font-medium title-font text-gray-900 mt-5">Budget Manager Bot</h2>
                            <p className="text-base leading-relaxed mt-2">
                                Budget Manager Bot bizneslarga moliyaviy jarayonlarni samarali boshqarishda yordam beradi.
                            </p>
                            <Link to="/loyihalarmiz/budget-manager-bot" className="text-indigo-500 inline-flex items-center mt-3">
                                Ko'rish
                                <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" className="w-4 h-4 ml-2" viewBox="0 0 24 24">
                                    <path d="M5 12h14M12 5l7 7-7 7"></path>
                                </svg>
                            </Link>
                        </div>
                    </div>
                </div>
            </section>

            <CTA />
            {/* <Fotter /> */}
        </>
    )
}

export default Projects
